import { render, staticRenderFns } from "./MagazzinoArticoliAnagraficaEditComponent.vue?vue&type=template&id=4655543e"
import script from "./MagazzinoArticoliAnagraficaEditComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliAnagraficaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports